<template>
  <v-dialog v-model="opened" max-width="800" persistent>
    <v-form
      ref="form"
      v-model="valid"
      :readonly="!canEdit"
      @submit.prevent="save()"
    >
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="headline">
          {{ !id ? " Tambah" : "Ubah" }} Cuti Member
          <v-btn icon @click="close()" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center" no-gutters>
              <v-col cols="12">
                <v-row dense>
                  <v-col cols="12" md="12">
                    <v-autocomplete
                    class="member-field"
                    label="Member"
                    dense
                    outlined
                    v-model="data.member_id"
                    :items="listMembers"
                    item-text="name"
                    item-value="id"
                    :rules="rules.member_id"
                    :readonly="!!id"
                    :clearable="!id"
                    :menu-props="{ disabled: !!id }"
                    :append-outer-icon="id ? 'mdi-lock' : undefined"
                    :hint="id ? 'Terkunci saat ubah data' : ''"
                    :persistent-hint="!!id"
                  />

                    <date-picker
                      class="mb-6"
                      placeholder="Tanggal Mulai"
                      valueType="format"
                      :format="'YYYY-MM-DD'"
                      v-model="data.start_date"
                      @change="calculateEndDate"
                    ></date-picker>

                    <v-row>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          label="Jumlah Hari Cuti"
                          dense
                          outlined
                          v-model="data.leave_days"
                          :items="listLeaveDays"
                          item-text="text"
                          item-value="value"
                          :rules="rules.leave_days"
                          clearable
                          @change="calculateEndDate"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                          <date-picker
                            placeholder="Tanggal Selesai"
                            valueType="format"
                            :format="'YYYY-MM-DD'"
                            v-model="data.end_date"
                            @change="calculateLeaveDays"
                          ></date-picker>
                      </v-col>
                    </v-row>
                    <CurrencyInput
                      v-model="data.price"
                      placeholder="Masukkan harga"
                      :rules="[v => !!v || 'Harga harus diisi']"
                    />
                    <v-autocomplete
                      label="Metode Pembayaran"
                      dense
                      outlined
                      v-model="data.payment_method_id"
                      :items="listPaymentMethods"
                      item-text="name"
                      item-value="id"
                      clearable
                      :rules="rules.payment_method_id"
                    />
                    <v-autocomplete
                      label="Bank Tujuan"
                      dense
                      outlined
                      v-model="data.destination_bank_id"
                      :items="listBanks"
                      item-text="name"
                      item-value="id"
                      clearable
                      :rules="rules.destination_bank_id"
                    />
                    <v-text-field
                      label="No. Rekening"
                      dense
                      outlined
                      v-model="data.account_number"
                      :rules="rules.account_number"
                    />
                    <v-text-field
                      label="Nama Rekening"
                      dense
                      outlined
                      v-model="data.account_name"
                    />
                    <v-col cols="12" md="12">
                      <div class="ml-3">Bukti Transfer</div>
                      <FileUpload
                        v-model="data.transfer_evidence_id"
                        :labelIdle="'Unggah Bukti Transfer'"
                        category="file"
                        :key="data.transfer_evidence_id"
                      ></FileUpload>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-autocomplete
                        v-if="canVerification"
                        label="Status"
                        dense
                        outlined
                        v-model="data.status"
                        :items="listStatuses"
                        item-text="name"
                        item-value="id"
                        clearable
                      />
                    </v-col>
                    <v-textarea
                      label="Keterangan"
                      dense
                      outlined
                      v-model="data.description"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-end mr-4">
          <v-btn
            depressed
            class="ma-1"
            :disabled="loading"
            @click="close()"
          >
            <v-icon small left>mdi-close</v-icon>
            Tutup
          </v-btn>
          <v-btn
            v-if="canEdit"
            type="submit"
            color="success"
            depressed
            class="ma-1"
            :loading="loading"
            :disabled="loading"
            @click.prevent="save()"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { slugify } from "@/core/utils";

import UploadAdapter from "../../../../core/plugins/UploadAdapter";

import FileUpload from "@/view/component/FileUpload.vue";

export default {
  async mounted() {
    const members = await ApiService.get("user/list?role_slug=member");
    this.listMembers = members.data;

    const paymentMethods = await ApiService.get("payment-method/list");
    this.listPaymentMethods = paymentMethods.data;

    const banks = await ApiService.get("bank/list");
    this.listBanks = banks.data;
  },
  data() {
    return {
      action: "create",
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      listMembers: [],
      listPaymentMethods: [],
      listBanks: [],
      listLeaveDays: [
        { value: 30, text: "30 Hari" },
        { value: 60, text: "60 Hari" },
        { value: 90, text: "90 Hari" },
        { value: 120, text: "120 Hari" },
        { value: 150, text: "150 Hari" },
        { value: 180, text: "180 Hari" },
        { value: 210, text: "210 Hari" },
        { value: 240, text: "240 Hari" },
        { value: 270, text: "270 Hari" },
        { value: 300, text: "300 Hari" },
        { value: 330, text: "330 Hari" },
        { value: 360, text: "360 Hari" }
      ],
      listStatuses: [
        { id: "unverified", name: "Belum Diverifikasi" },
        { id: "verified", name: "Diverifikasi" }
      ],
      data: {
        leave_in_month: null,
        member_id: null,
        description: null,
        price: null,
        payment_method_id: null,
        destination_bank_id: null,
        account_number: null,
        account_name: null,
        status: "unverified",
        transfer_evidence_id: null,
        leave_days: null,
        start_date: null,
        end_date: null
      },
      rules: {
        member_id: [
          v => !!v || "Member harus dipilih",
          v => v.length > 0 || "Member harus dipilih"
        ],
        price: [
          v => !!v || "Biaya harus diisi",
          v => v.length > 0 || "Biaya harus diisi"
        ],
        start_date: [
          v => !!v || "Tanggal mulai harus diisi",
          v => v.length > 0 || "Tanggal mulai harus diisi"
        ],
        end_date: [
          v => !!v || "Tanggal selesai harus diisi",
          v => v.length > 0 || "Tanggal selesai harus diisi"
        ],
        payment_method_id: [
          v => !!v || "Metode pembayaran harus dipilih",
          v => v.length > 0 || "Metode pembayaran harus dipilih"
        ],
        destination_bank_id: [
          v => !!v || "Bank tujuan harus dipilih",
          v => v.length > 0 || "Bank tujuan harus dipilih"
        ],
        account_number: [
          v => !!v || "No. rekening harus diisi",
          v => v.length > 0 || "No. rekening harus diisi"
        ],
        account_name: [
          v => !!v || "Nama rekening harus diisi",
          v => v.length > 0 || "Nama rekening harus diisi"
        ],
        leave_days: [
          v => !!v || "Jumlah hari cuti harus dipilih",
          v => v > 0 || "Jumlah hari cuti harus dipilih"
        ]
      }
    };
  },
  props: {
    module: {
      type: String
    },
    success: {
      type: Function,
      default: function() {}
    }
  },
  methods: {
    open(id) {
      this.opened = true;
      setTimeout(() => {
        this.$refs.form.reset();
        if (id) {
          this.getData(id);
        }
      }, 1);
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      ApiService.get("leave-request?id=" + id)
        .then(({ data }) => {
          this.data = {
            slug: data.slug,
            name: data.name,
            price: data.price,
            description: data.description,
            start_date: data.start_date,
            end_date: data.end_date,
            member_id: data.member_id,
            payment_method_id: data.payment_method_id,
            destination_bank_id: data.destination_bank_id,
            account_number: data.account_number,
            account_name: data.account_name,
            status: data.status,
            transfer_evidence_id: data.transfer_evidence_id,
            leave_days: data.leave_days
          };
          
          this.calculateLeaveDays();
          this.loadingData = false;
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleError(response.data);
          }
          this.loadingData = false;
        });
    },
    async save() {
      this.$refs.form.validate();
      
      // Additional validation for date range
      if (!this.validateDateRangeAndShowError()) {
        return;
      }
      
      if (this.valid) {
        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "leave-request";
        if (this.id) {
          url = url + "?id=" + this.id;
        }
        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000
        });
      }
    },
    close() {
      this.opened = false;
      this.id = null;
      this.$refs.form.reset();
      this.data = {};
      this.success();
    },
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new UploadAdapter(loader, "file");
      };
    },
     calculateEndDate() {
       if (this.data.start_date && this.data.leave_days) {
         const startDate = new Date(this.data.start_date);
         const endDate = new Date(startDate);
         endDate.setDate(startDate.getDate() + this.data.leave_days);

         // Format the date as YYYY-MM-DD
         const year = endDate.getFullYear();
         const month = String(endDate.getMonth() + 1).padStart(2, "0");
         const day = String(endDate.getDate()).padStart(2, "0");

         this.data.end_date = `${year}-${month}-${day}`;
       }
     },
     calculateLeaveDays() {
       if (this.data.start_date && this.data.end_date) {
         const startDate = new Date(this.data.start_date);
         const endDate = new Date(this.data.end_date);
         
         // Calculate the difference in days
         const timeDiff = endDate.getTime() - startDate.getTime();
         const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
         
         // Find the nearest available option (round up)
         const availableDays = this.listLeaveDays.map(item => item.value).sort((a, b) => a - b);
         const nearestDay = availableDays.find(day => day >= daysDiff);
         
         if (nearestDay) {
           this.data.leave_days = nearestDay;
         } else {
           // If calculated days exceed all available options, use the maximum available
           this.data.leave_days = availableDays[availableDays.length - 1];
         }
       }
     },
     validateDateRange(startDate, endDate) {
       if (!startDate || !endDate) {
         return true; // Let other validation rules handle empty values
       }
       
       const start = new Date(startDate);
       const end = new Date(endDate);
       
       // Calculate the difference in days
       const timeDiff = end.getTime() - start.getTime();
       const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
       
       return daysDiff >= 30;
     },
     validateDateRangeAndShowError() {
       if (!this.validateDateRange(this.data.start_date, this.data.end_date) && !this.id) {
          this.$swal.fire({
            icon: "warning",
            title: "Periode Cuti Tidak Valid",
            text: "Periode cuti minimal 30 hari",
            showConfirmButton: true,
           timer: 5000
         });
         this.data.end_date = null;
         return false;
       }
       return true;
     }
  },
  watch: {
    ["data.name"](value) {
      this.data.slug = value ? slugify(value) : null;
    },
    ["data.start_date"](value) {
      if (value && this.data.end_date) {
        this.validateDateRangeAndShowError();
      }
    },
    ["data.end_date"](value) {
      if (value && this.data.start_date) {
        this.validateDateRangeAndShowError();
      }
    }
  },
  components: {
    FileUpload
  },
  computed: {
    canEdit() {
      if (
        this.id &&
        !this.$store.getters.hasPermission(this.module, "update")
      ) {
        return false;
      }

      return true;
    },
    canVerification() {
      return (
        this.id &&
        this.$store.getters.hasPermission(this.module, "verification")
      );
    }
  }
};
</script>
